export default __webpack_public_path__ + "static/media/angle-right.3fdcdcfa.svg";